// extracted by mini-css-extract-plugin
module.exports = {"header":"motion-header_header__OEehW","titleWrapper":"motion-header_titleWrapper__nJ8N8","separator":"motion-header_separator__7HaEP"};